/**
 * Typography Enums Export
 * Re-exports typography enums for use in components
 */

export { FontFamily, FontWeight } from '@/theme/typography';

